// Reference snapshot, not a live quote. Update the rate and date together.
export const USD_KRW_REFERENCE = {
  rate: 1339.48,
  date: "2026-10-15",
  source: "Exchange Rates UK",
  url: "https://www.exchangerates.org.uk/USD-KRW-spot-exchange-rates-history-2026.html",
};

export function formatEstimatedKrw(usd) {
  if (typeof usd !== "number" || !Number.isFinite(usd) || usd < 0) return null;
  const krw = usd * USD_KRW_REFERENCE.rate;
  if (krw > 0 && krw < 0.01) return "약 0.01원 미만";
  return `약 ${krw.toLocaleString("ko-KR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}원`;
}
